import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getDataForViewService } from "../../../services/dashboardServices";
import ViewCarePlan from "./ViewCarePlan";

const CarePlanViewPage = () => {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [meta, setMeta] = useState({ id: null, version: null });
  const [error, setError] = useState();

  useEffect(() => {
    getDataForViewService(publicId)
      .then((data) => setMeta({ id: data.id, version: data.version }))
      .catch((err) => setError(err.message || "Failed to load"));
  }, [publicId]);

  const handleClose = () => {
    // replace "/care-plans/<something>" (with or without trailing slash)
    // with "/draft-care-plans"
    const newPath = location.pathname.replace(
      /\/care-plans\/[^/]+\/?$/,
      "/draft-care-plans"
    );
    navigate(newPath, { replace: true });
  };

  if (error) return <div>Error: {error}</div>;
  if (!meta.id) return <div>Loading…</div>;

  return (
    <ViewCarePlan
      carePlanId={meta.id}
      version={meta.version}
      onClose={handleClose}
    />
  );
};

export default CarePlanViewPage;
